import { I } from "./Icons";

interface Props {
  stage: "ms-account" | "ms-loading";
  onPick: () => void;
  onCancel: () => void;
}

export function MicrosoftSheet({ stage, onPick, onCancel }: Props) {
  return (
    <div className="gf-ms-backdrop" onClick={onCancel}>
      <div className="gf-ms" onClick={(e) => e.stopPropagation()}>
        <div className="gf-ms__logo">
          <div className="gf-ms__logo-grid">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <span className="gf-ms__logo-text">Microsoft</span>
        </div>

        {stage === "ms-account" && (
          <>
            <h3>Pick an account</h3>
            <div className="gf-ms__signin">
              <div className="gf-ms__account" onClick={onPick}>
                <div className="gf-ms__account-avatar">EW</div>
                <div>
                  <div className="gf-ms__account-name">Erin Walsh</div>
                  <div className="gf-ms__account-email">
                    erin.walsh@nymbl.app
                  </div>
                </div>
              </div>
              <div
                className="gf-ms__account"
                style={{ color: "#6e6e6e" }}
              >
                <div
                  className="gf-ms__account-avatar"
                  style={{ background: "#e1e1e1", color: "#666" }}
                >
                  <I.Plus size={16} />
                </div>
                <div>
                  <div
                    className="gf-ms__account-name"
                    style={{ color: "#1b1b1b" }}
                  >
                    Use another account
                  </div>
                </div>
              </div>
            </div>
            <div className="gf-ms__actions">
              <button
                className="gf-ms__btn gf-ms__btn--ghost"
                onClick={onCancel}
              >
                Back
              </button>
            </div>
          </>
        )}

        {stage === "ms-loading" && (
          <>
            <h3>Signing you in…</h3>
            <p>erin.walsh@nymbl.app</p>
            <div className="gf-ms__loading">
              <div className="gf-ms__spinner"></div>
              <div style={{ fontSize: 12, color: "#6e6e6e" }}>
                Verifying with Nymbl tenant
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export function MSLogo() {
  return (
    <div
      className="gf-ms__logo-grid"
      style={{ width: 18, height: 18, marginRight: 0 }}
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
